/* eslint-disable no-plusplus */
// eslint-disable-next-line import/no-named-default
import { default as AnsiUp } from 'ansi_up';
import LimitMap from './LimitMap';
import Searcher from './Searcher';
import type { ISearchOptions } from '../SearchAddon';

export default class Logs {
  private id: string;

  private string: string;

  private searcher: Searcher;

  private logDataMap: LimitMap;

  constructor({ id, string }: { id: string; string: string }) {
    this.id = id;
    this.string = string;
    this.searcher = new Searcher();
    this.logDataMap = new LimitMap({ limit: 1 });
  }

  convert() {
    if (this.string.length === 0) {
      return [];
    }
    return this.string.split('\r\n').map((content) => new AnsiUp().ansi_to_html(content));
  }

  getArrayData() {
    if (!this.logDataMap.has(this.id)) {
      this.logDataMap.set(this.id, this.convert());
    }
    return this.logDataMap.get(this.id) || [];
  }

  mark(keyword: string, hlIndex = 0, options: ISearchOptions | undefined = undefined) {
    if (!keyword) {
      return this.searcher.search(keyword, []);
    }
    return this.searcher.search(keyword, this.getArrayData(), hlIndex, options);
  }
}
